module.exports = __webpack_public_path__ + "img/finish.2194446d.svg";